import { Domain, Locale } from '../types';

interface PhoneNumberEntity {
  href: string;
  label: string;
}

type PhoneNumberEntityByLocale = Partial<Record<Locale, PhoneNumberEntity>>;
type PhoneNumberEntityByDomain = Record<Domain, PhoneNumberEntityByLocale>;

export const HOTLINE_PHONE: PhoneNumberEntityByDomain = {
  ru: {
    ru: {
      href: '88002003600',
      label: '8 800 200-36-00',
    },
    kz: {
      href: '88002003600',
      label: '8 800 200-36-00',
    },
    en: {
      href: '88002003600',
      label: '8 800 200-36-00',
    },
    am: {
      href: '88002003600',
      label: '8 800 200-36-00',
    },
    ge: {
      href: '88002003600',
      label: '8 800 200-36-00',
    },
    tg: {
      href: '88002003600',
      label: '8 800 200-36-00',
    },
  },
  kz: {
    ru: {
      href: '+77719290107',
      label: '+7 771 929-01-07',
    },
    kz: {
      href: '+77719290107',
      label: '+7 771 929-01-07',
    },
    en: {
      href: '+77710834813',
      label: '+7 771 083-48-13',
    },
    am: {
      href: '+77710834813',
      label: '+7 771 083-48-13',
    },
    ge: {
      href: '+77710834813',
      label: '+7 771 083-48-13',
    },
    tg: {
      href: '+77710834813',
      label: '+7 771 083-48-13',
    },
  },
  com: {},
  am: {},
  ge: {},
  tj: {},
};
